import gql from "graphql-tag";

export const UPDATE_COMPANY_ASSETS = gql`
  mutation updateCompanyAssets($companyCreationId: ID!, $assets: [CompanyAssets!]!) {
    updateCompanyAssets(companyCreationId: $companyCreationId, assets: $assets) {
      feedback
    }
  }
`;
